module.exports = __webpack_public_path__ + "p.no1.89bc142b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/p.no1.jpg
// module id = Nlgu
// module chunks = 0